import React from 'react'
import { useForm } from 'react-hook-form'
import { connect, useSelector, useDispatch } from 'react-redux'
import axios from 'axios';
import { Fragment, useState, useRef } from 'react'
import FormFields from '../components/form_fields.jsx'
import EventGroups from '../components/event_groups.jsx'
import Footer from '../components/footer.jsx'
import Sidebar from '../components/sidebar.jsx'
import ClosedPage from '../components/closed_page.jsx'
import ThankYouPage from '../components/thank_you_page.jsx'
import Dsgvo from '../components/dsgvo.jsx'
import Rfid from '../components/rfid.jsx'
import classNames from 'classnames'
import {serialize} from "object-to-formdata";

// ******************** REGISTRATION PAGE (APP) ******************** //

let RegistrationPage = function() {

 const methods = useForm({shouldUnregister: true});
  const dispatch = useDispatch();
  const { handleSubmit, register, setValue, formState: { errors }, setError} = methods;
  

    // Prefilled Data

  const guest_list_entries = useSelector(state => state.guestListEntries)
  const tagOwner = useSelector(state => state.tagOwner)

    // Preferences
  
  const companionConfig =  useSelector(state => state.companion)

  let decline_mode = "disabled"

  if(useSelector(state => state.decline_mode) != "" ){
    decline_mode = useSelector(state => state.decline_mode)
  }

  // const prefilled = useSelector(state => state.prefilled)
  let prefilled = false

  if (useSelector(state => state.prefix) == "prefilled"){
    prefilled = true
  }

  const mode = prefilled ? "put" : "post" 
  const disabled_prefilled_fields = useSelector(state => state.disabled_prefilled_fields)

  const saveUrl = useSelector(state => state.saveUrl)

    // Structure Options
  
  const input_width = useSelector(state => state.input_width) ? useSelector(state => state.input_width) : "8"
  const label_width = useSelector(state => state.label_width) ? useSelector(state => state.label_width) : "3"

  // Registration Status

  const closed = useSelector(state => state.closed)  
  const stop = useSelector(state => state.stop)
  const full = useSelector(state => state.full)


  // ******************** CONTENT: ******************** //
  //              sorted by Page-Structure              //    
  let tab_title = useSelector(state => state.tab_title).trim()
  if (tab_title != "" || tab_title != null) document.title = tab_title
  let head_code = useSelector(state => state.head_code)
  let headerText = useSelector(state => state.headerText).trim()
  let headerHeadline = useSelector(state => state.headerHeadLine).trim()
  let formHeaderText = useSelector(state => state.formHeaderText).trim()
  let companionCheckboxText = useSelector(state => state.companion.checkbox_text)
  let companionHeaderText = useSelector(state => state.companion.header_text)
  let rfidText = useSelector(state => state.rfid.text).trim()
  let submitButtonText = useSelector(state => state.submitButtonText)
  let submitButtonSendingText = useSelector(state => state.submitButtonSendingText)
  let declineButtonText = useSelector(state => state.decline_button_text)
  let acceptRadioButtonText = useSelector(state => state.accept_radio_button_text)
  let declineRadioButtonText = useSelector(state => state.decline_radio_button_text)
  let full_width_footer = useSelector(state => state.full_width_footer)
  let thankYouRedirectEnabled = useSelector(state => state.thank_you_redirect_enabled)
  let thankYouRedirectUrl = useSelector(state => state.thank_you_redirect_url)
  let thankYouRedirectDelay = useSelector(state => state.thank_you_redirect_delay)
  let closedRedirectEnabled = useSelector(state => state.closed_redirect_enabled)
  let closedRedirectUrl = useSelector(state => state.closed_redirect_url)
  let closedRedirectDelay = useSelector(state => state.closed_redirect_delay)


  const [finished, setFinished] = useState(false)
  const [sendingAccept, setSendingAccept] = useState(false)
  const [sendingDecline, setSendingDecline] = useState(false)
  const [doDecline, setDecline] = useState(false);
  const [thankYouText, setThankYouText] = useState(useSelector(state => state.thankYouText));
  const [thankYouHeadline, setThankYouHeadline] = useState(useSelector(state => state.thankYouHeadline));

  let [activeForm, setForm] = useState();

  if (decline_mode == "with_radio_button_without_form"){
    [activeForm, setForm] = useState(false);
  } else {
    [activeForm, setForm] = useState(true);
  }

  let open_companion = function(e){
    let companion_content = document.querySelector(".companion-content")
    if (e.target.checked){
      companion_content.classList.remove("companion-hide");
    } else {
      companion_content.classList.remove("companion-hide");
      companion_content.classList.add("companion-hide");
    }
  }


  // ******************** SUBMIT-ACTIONS: ******************** //

  const onSubmit = (data, e) => {
    console.log("onSubmit", data)
    let accept = document.querySelector(".submit")
    let decline = document.querySelector(".decline")
    if(typeof data.decline == 'undefined'){
      data.decline = {}
      data.decline.status = doDecline
    } else {
      if (data.decline.status == "" && doDecline == false){
        data.decline.status = ""
      } else if (data.decline.status == "1") {
        data.decline.status = true
      } else {
        data.decline.status = false
      }
    }
    if (doDecline) {
      setSendingDecline(true)
    } else {
      setSendingAccept(true)
    }
    const serializeOptions = {
      booleansAsIntegers: true,
    }
    data = serialize(data, serializeOptions)

    // bei prefilled: put
    axios({ method: mode, url: saveUrl, data: data, headers: { 'Content-Type': 'application/json' }, timeout: 30 * 1000} ).then(response => {
      console.log("success:", response)
      // console.log("response", response.data)
      if(response.data.status == "OK") {
        // console.log(response.data.errors)
        console.log("Validataion: %cOK", " background-color: green;")
        if (thankYouRedirectEnabled && thankYouRedirectUrl != ""){
          if (thankYouRedirectDelay >= 0) {
            setTimeout(function() {
              window.location = response.data.data.thank_you_redirect_url.replace("@tag_owner_id@", response.data.data.tagOwner ? response.data.data.tagOwner.id : "");
            }, thankYouRedirectDelay)
          } else {
            window.location = response.data.data.thank_you_redirect_url.replace("@tag_owner_id@", response.data.data.tagOwner ? response.data.data.tagOwner.id : "");
          }
        }
        setFinished(true)
        setThankYouText(response.data.data.thankYouText)
        setThankYouHeadline(response.data.data.thankYouHeadline)
      } else {
        
        _.map(response.data.errors, (messages, field) => {
          let multiple = false
          if (messages.length > 1){
            multiple = true
          }
          {_.map(messages, (message, index) => {
            if (index == 0 && multiple){
              setError(field, { type: "not valid", message: [message]})
            } else if (multiple){
              let splitted = field.split(".")
              setError(field, { type: "not valid", message: [...errors[splitted[0]][splitted[1]].message, message]})
            } else{
              setError(field, { type: "not valid", message: message })
            }
          })}
        })

        if(accept !== null) accept.disabled = false
        if(decline !== null) decline.disabled = false
        setSendingAccept(false)
        setSendingDecline(false)
        console.log("Validataion: %cNOT OK", " background-color: red;")
        console.log("Errors:", response.data.errors)
        console.log("Errors:", errors)

        setTimeout(function() {
          document.getElementsByClassName("is-invalid")[0].parentElement.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }, 200)
      }
    }).catch((response) => {  
      alert(response)
      console.error(response)
      setSendingAccept(false)
      setSendingDecline(false)
    })
  }

  console.log({sendingDecline, sendingAccept})

  // ******************** OUTPUT: ******************** //
  if(finished == true || errors["tag_owner.stop"] || stop) {
    if (thankYouRedirectEnabled && thankYouRedirectUrl != "" && !thankYouRedirectUrl.includes("@tag_owner_id@")){
      if (thankYouRedirectDelay && thankYouRedirectDelay >= 0) {
        setTimeout(function() {
          window.location = thankYouRedirectUrl;
        }, thankYouRedirectDelay)
        return (<ThankYouPage thankYouText={thankYouText} thankYouHeadline={thankYouHeadline} doDecline={doDecline}/>)
      } else {
        window.location = thankYouRedirectUrl;
        return null
      }
    } else {
      return (<ThankYouPage thankYouText={thankYouText} thankYouHeadline={thankYouHeadline} doDecline={doDecline}/>)
    }
  } else if (closed || full || errors["tag_owner.full"]){
    if (closedRedirectEnabled && closedRedirectUrl != ""){
      if (closedRedirectDelay && closedRedirectDelay >= 0) {
        setTimeout(function() {
          window.location = closedRedirectUrl;
        }, closedRedirectDelay)
        return (<ClosedPage/>)
      } else {
        window.location = closedRedirectUrl;
        return null
      }
    } else {
      return (<ClosedPage/>)
    }
  } else {

    return (
      <div className="r-container row">
        <div className="col">
          <div className="row">
            <div className="r-header col-sm-12">
              <h1 dangerouslySetInnerHTML={{ __html: headerHeadline}} id="header_headline" className="page-header r-header-headline col-sm-12 mb-4 pt-4"></h1>
            </div>
          </div>
          <div className="r-inner-container row">
            <div className="col">
              {headerText &&
                <div className="row">
                  <div dangerouslySetInnerHTML={{ __html: headerText}} className="r-header-text col-sm-12"/>
                </div>
                }
              {formHeaderText &&
                <div className="r-form-header col">
                  <div className="r-form-header-text" dangerouslySetInnerHTML={{ __html: formHeaderText}}></div>
                </div>
              }
              <div className="row">
                <form className="r-form col-md-12" onSubmit={handleSubmit(onSubmit)}>
                  {decline_mode != "disabled" && decline_mode != "with_button" &&
                    <div className="form-group r-submit row">
                      <span className={"col-md-" + label_width + " r-label col-form-label optional-label"}></span>
                      <div className="submit-div">
                        <div className="d-flex align-items-center">
                          {decline_mode == "with_radio_button_without_form" && <input {...register("decline.status")} onClick={e => {setForm(false); setDecline(true);}} id="decline" type="radio" value="1" className="mr-2" />}
                          {decline_mode == "with_radio_button_with_form" && <input {...register("decline.status")} id="decline" type="radio" value="1" className="mr-2" />}
                          <label htmlFor="decline" className="form-check-label r-label ml-1 w-80" dangerouslySetInnerHTML={{ __html: declineRadioButtonText}}></label>
                        </div>
                        <div className="d-flex align-items-center">
                          {decline_mode == "with_radio_button_without_form" && <input {...register("decline.status")} onClick={e => {setForm(true); setDecline(false);}} id="accept" type="radio" value="0" className="mr-2" />}
                          {decline_mode == "with_radio_button_with_form" && <input {...register("decline.status")} id="accept" type="radio" value="0" className="mr-2" />}
                          <label htmlFor="accept" className="form-check-label r-label ml-1 w-80" dangerouslySetInnerHTML={{ __html: acceptRadioButtonText}}></label>
                        </div>
                        {errors["tag_owner.decline"] && <div className="is-invalid" dangerouslySetInnerHTML={{ __html: errors["tag_owner.decline"].message}}></div>}
                      </div>
                    </div>
                  }
                  {activeForm &&
                    <Fragment>
                      <FormFields tagOwner={tagOwner} fieldType={"tag_owner"}  methods={methods} register={register} errors={errors}/>
                      {companionConfig.show_event_selection &&
                        <EventGroups register={register} errors={errors} fieldType={"tag_owner"}/>
                      }
                      {companionConfig.enabled &&
                        <Fragment>
                          <div className="form-group row companion-row" key={"col" +  "companion"}>
                            <div className={"col-md-" + input_width + " offset-md-" + label_width}>
                              <div className="form-check">
                                <input {...register("companion_enabled.status")} id="tag_owner.companion" onClick={open_companion} type="checkbox" className={classNames("form-check-input companion-checkbox", {"is-invalid": errors["companion.base"] })}/>
                                <label htmlFor="tag_owner.companion" className="form-check-label" dangerouslySetInnerHTML={{ __html: companionCheckboxText }}></label>
                              </div>
                              {errors?.companion_enabled?.status?.message && <div className="invalid-feedback d-block" dangerouslySetInnerHTML={{ __html: errors.companion_enabled.status.message}}></div>}
                            </div>
                          </div>
                          <div className="companion-content companion-hide">
                            {companionHeaderText &&
                              <div className="form-group row">
                                <span className={"r-label col-md-" + label_width + " col-form-label optional-label"}></span>
                                <div className={"col-md-" + input_width + ""} dangerouslySetInnerHTML={{ __html: companionHeaderText }}></div>
                              </div>
                            }
                            <FormFields tagOwner={null} fieldType={"companion"} methods={methods} register={register} errors={errors}/>
                            {companionConfig.show_event_selection && 
                              <EventGroups register={register} errors={errors} fieldType={"companion"}/>
                            }
                          </div>
                        </Fragment>
                      }
                      {!companionConfig.show_event_selection &&
                        <EventGroups register={register} errors={errors} fieldType={"tag_owner"}/>
                      }
                      <Dsgvo register={register} errors={errors}/>
                      <Rfid register={register} errors={errors}/>
                    </Fragment>
                  }
                  <div className="form-group r-submit row">
                    <div className={"r-label col-md-" + label_width + " col-form-label optional-label"}></div>
                    <div className={"r-submit-container col-sm flex-wrap"}>
                      <Fragment>
                        <div className={decline_mode && decline_mode == "with_button" ? "submit-div sub-btn" : "submit-div" }>
                          <button onClick={e => {handleSubmit(onSubmit);}} id="btnSubmit" name="decline.status" disabled={sendingAccept || sendingDecline ? true : ""} className={classNames("btn btn-success submit", {"spinner-btn": sendingAccept})}>
                              <i className={classNames("submit-icon fa mr-2", {"fa-spinner fa-spin": sendingAccept}, { "submit-icon fa fa-check": !sendingAccept})}></i>
                              <span dangerouslySetInnerHTML={{ __html: sendingAccept ? submitButtonSendingText : submitButtonText}} ></span>
                          </button>
                        </div>
                      </Fragment>
                      {decline_mode &&
                        <Fragment>
                          {decline_mode == "with_button" &&
                            <div className="submit-div sub-btn">
                              <button onClick={e => {setDecline(true); handleSubmit(onSubmit);}} id="btnSubmit" name="decline.status" disabled={sendingAccept || sendingDecline ? "{true}" : ""} className={classNames("btn btn-danger decline", {"spinner-btn": sendingDecline})}>
                                <i className={classNames("submit-icon fa mr-2", {"fa-spinner fa-spin": sendingDecline}, { "submit-icon fa fa-times": !sendingDecline})}></i>
                                <span dangerouslySetInnerHTML={{ __html: sendingDecline ? submitButtonSendingText : declineButtonText}} ></span>
                              </button>
                            </div>
                          }
                        </Fragment>
                      }
                    </div>
                  </div>
                </form>
              </div>
              <Footer/>
          </div>
              <Sidebar/>
          </div>
        </div>
      </div>
    );
  }
}

export default (RegistrationPage);
